<template>
  <v-alert class="text-body-1" density="compact" variant="tonal">
    <slot />
  </v-alert>
</template>
